import createToolLogger from "./tool";
export default function createBrowserLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `browser:${input.type}` });
    return {
        closed() {
            return log({
                type: "closed",
            });
        },
        disposed() {
            return log({
                type: "disposed",
            });
        },
        tool: createToolLogger(log),
    };
}
